(() => {
    const root =
        (document.currentScript && document.currentScript.closest('.oct-nav-stepper')) ||
        document.querySelector('.oct-nav-stepper');
    if (!root) return;

    const list = root.querySelector('.oct-nav-stepper__list');
    if (!list) return;

    // -------------------- config --------------------
    const dataEl = root.querySelector('script[id^="oct-nav-stepper-data-"]');
    const cfg = dataEl ? JSON.parse(dataEl.textContent || '{}') : {};
    const labelsCfg = Array.isArray(cfg.steps) ? cfg.steps.map(s => (s.label || '').trim()) : [];
    const resultsLabel = (cfg.resultsLabel || 'Results').trim();
    const resultsIsLast =
        labelsCfg.length > 0 && labelsCfg[labelsCfg.length - 1].toLowerCase() === resultsLabel.toLowerCase();

    // -------------------- state --------------------
    const indexByKey = new Map();
    const stepsKeys = [];
    let currentIdx = 0;

    const questionSlots = resultsIsLast ? Math.max(0, labelsCfg.length - 1) : labelsCfg.length;
    const totalDots = resultsIsLast ? questionSlots + 1 : questionSlots;

    // -------------------- helpers --------------------
    const norm = s => (s || '').trim();
    const isOnResults = () => resultsIsLast && currentIdx >= questionSlots;

    const keyOf = d => {
        const id = d?.question_id;
        if (id != null && String(id).trim() !== '') return String(id);
        return norm(d?.question_title).toLowerCase();
    };

    const labelFor = i => (i < questionSlots ? labelsCfg[i] || `Step ${i + 1}` : resultsLabel);

    function rebuildIndex() {
        indexByKey.clear();
        stepsKeys.forEach((k, i) => indexByKey.set(k, i));
    }

    function ensureStep(d) {
        const k = keyOf(d);
        if (!k) return null;

        if (indexByKey.has(k)) {
            const idx = indexByKey.get(k);
            if (idx < stepsKeys.length - 1) {
                stepsKeys.splice(idx + 1);
                rebuildIndex();
                render();
            }
            return idx;
        }

        if (currentIdx < stepsKeys.length - 1) {
            stepsKeys.splice(currentIdx + 1);
            rebuildIndex();
        }

        const next = stepsKeys.length;
        stepsKeys.push(k);
        indexByKey.set(k, next);
        render();
        return next;
    }

    function render() {
        list.innerHTML = '';
        const total = Math.max(totalDots, stepsKeys.length + (resultsIsLast ? 1 : 0));

        for (let i = 0; i < total; i++) {
            const li = document.createElement('li');
            li.className = 'oct-nav-step';
            li.dataset.index = String(i);
            li.innerHTML = `
        <span class="oct-nav-step__dot" aria-hidden="true"></span>
        <span class="oct-nav-step__label">${labelFor(i)}</span>
      `;
            list.appendChild(li);
        }

        const items = list.querySelectorAll('.oct-nav-step');
        const n = items.length;
        items.forEach((li, i) => {
            const pct = n <= 1 ? 0 : (i / (n - 1)) * 100;
            li.style.left = pct + '%';
        });

        updateUI();
        wireClicks();
    }

    function updateUI() {
        const canBack = root.dataset.enableBack === 'true';
        const onResults = isOnResults();
        const prevIdx = currentIdx - 1;

        const items = list.querySelectorAll('.oct-nav-step');
        items.forEach((li, i) => {
            li.classList.toggle('is-active', i === currentIdx);
            li.classList.toggle('is-done', i < currentIdx);

            const isPrev = (i === prevIdx) && i >= 0 && i < questionSlots;
            const clickable = canBack && isPrev && !onResults;

            li.classList.toggle('is-clickable', clickable);
            li.setAttribute('aria-disabled', String(!clickable));

            const dot = li.querySelector('.oct-nav-step__dot');
            const cursorValue = clickable ? 'pointer' : 'default';
            li.style.cursor = cursorValue;
            if (dot) dot.style.cursor = cursorValue;
        });
    }

    // -------------------- Back support (fixed) --------------------
    function findBackButton() {
        const wrap =
            document.querySelector(root.dataset.quizWrapperSelector || '.oct-quiz-wrapper') ||
            root.closest('.oct-quiz-wrapper') ||
            root;

        const trySelectors = (scope, sels) => {
            for (const sel of sels) {
                const el = scope.querySelector(sel);
                if (el) return el;
            }
            return null;
        };

        return trySelectors(wrap, [
            '[data-element*="oct-quiz-go-back"]',
            '.oct-quiz-go-back',
            '.oct-quiz-back',
            'button[title="back"]',
            'button[title="Back"]',
            'button[aria-label="back"]',
            'button[aria-label="Back"]'
        ]);
    }

    function clickBack(times) {
        const stepsToGo = Math.max(0, Number(times) | 0);
        if (!stepsToGo) return;

        let left = stepsToGo;

        const stepOnce = () => {
            if (left <= 0) return;

            freezeScroll(600);

            const btn = findBackButton();

            if (btn) {
                try { btn.focus({ preventScroll: true }); } catch (e) {}
                btn.click();
            } else {
                document.dispatchEvent(new CustomEvent('octane.quiz.goBack', { bubbles: true }));
            }

            left -= 1;
            setTimeout(stepOnce, 250);
        };

        stepOnce();
    }


    let _freezeTimer = null;
    function freezeScroll(ms = 700) {
        clearTimeout(_freezeTimer);
        const y = window.pageYOffset || document.documentElement.scrollTop || 0;
        const rootEl = document.scrollingElement || document.documentElement;
        const prevBehavior = rootEl.style.scrollBehavior = 'auto';

        let frames = 10;
        const hold = () => {
            window.scrollTo(0, y);
            if (frames-- > 0) requestAnimationFrame(hold);
        };
        hold();

        _freezeTimer = setTimeout(() => {
            rootEl.style.scrollBehavior = prevBehavior;
        }, ms);
    }

    let navLock = false;

    function wireClicks() {
        if (list._octClicks) return;
        list._octClicks = true;

        list.addEventListener(
            'click',
            e => {
                e.preventDefault();
                e.stopPropagation();
                if (root.dataset.enableBack !== 'true') return;

                if (isOnResults()) return;

                const item = e.target.closest('.oct-nav-step');
                if (!item) return;

                const target = parseInt(item.dataset.index, 10);
                if (Number.isNaN(target)) return;

                const prevIdx = currentIdx - 1;
                if (target !== prevIdx || target < 0 || target >= questionSlots) return;

                if (navLock) return;
                navLock = true;

                freezeScroll(800);
                if (document.activeElement) document.activeElement.blur();

                clickBack(1);

                setTimeout(() => { navLock = false; }, 700);
            },
            false
        );
    }

    // -------------------- Q3 bottom-content relocation --------------------
    function isQuestion3(detail, wrap) {
        const qRoot = wrap || detail?.quiz_wrapper_element || document.querySelector('.oct-quiz-wrapper');

        if (Number.isInteger(detail?.idx) && detail.idx === 3) return true;
        if (qRoot && (qRoot.classList.contains('question-3') || qRoot.parentElement?.classList.contains('question-3'))) {
            return true;
        }
        const t = (detail?.question_title || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (t === 'narrow down your shade') return true;
        if (/undertone\s*correct|correct\s*undertone/.test(t)) return true;

        const id = String(detail?.question_id || '');
        if (id) {
            const idsAttr = qRoot?.dataset?.q3Ids || document.body?.dataset?.q3Ids || '';
            if (
                idsAttr
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean)
                    .includes(id)
            ) return true;
        }

        const hasBottom = !!qRoot?.querySelector('.oct-quiz-bottom_content');
        const hasChoices = !!qRoot?.querySelector('.oct-quiz-picture-choice-wrapper .oct-quiz-picture-choice-options');
        return hasBottom && hasChoices;
    }

    function moveBottomContentForQ3(detail) {
        const wrap = detail?.quiz_wrapper_element || document.querySelector('.oct-quiz-wrapper');
        if (!wrap) return;
        if (!isQuestion3(detail, wrap)) return;

        const bottom = wrap.querySelector('.oct-quiz-bottom_content');
        const btnWrap = wrap.querySelector('.oct-quiz-btn-wrapper');
        const choice = wrap.querySelector('.oct-quiz-picture-choice-wrapper');
        if (!bottom || !btnWrap || !choice) return;

        if (btnWrap.previousElementSibling === bottom) return;
        btnWrap.before(bottom);
    }

    // блокируем клики по самому списку как навигационные ссылки
    root.addEventListener(
        'click',
        e => {
            if (e.target.closest('.oct-nav-stepper__list')) {
                e.preventDefault();
            }
        },
        true
    );

    // -------------------- Events --------------------
    document.addEventListener(
        'octane.quiz.questionLoaded',
        e => {
            const d = e.detail || {};
            const idx = ensureStep(d);
            if (idx != null) {
                currentIdx = idx;
                updateUI();
            }
            moveBottomContentForQ3(d);
        },
        { passive: true }
    );

    document.addEventListener(
        'octane.quiz.completed',
        () => {
            const total = Math.max(totalDots, stepsKeys.length + (resultsIsLast ? 1 : 0));
            currentIdx = Math.max(0, total - 1);
            updateUI();
        },
        { passive: true }
    );

    // initial render
    render();
})();
